import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export enum ProductTag {
  RETURNED = 'EDIT_EXIST_PRODUCT',
  NEW = 'NEW_PRODUCT',
  REJECTED = 'REJECTED',
}

export interface ProductsState {
  filters?: {
    fromDate?: string;
    toDate?: string;
    tags?: ProductTag[];
  };
}

const initialState: ProductsState = {
  filters: {},
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProductFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetProductFilters: (state) => {
      state.filters = {};
    },
  },
});

export const { setProductFilters, resetProductFilters } = productsSlice.actions;

export const useProductsState = () =>
  useSelector((state: RootState) => state?.products);

export default productsSlice.reducer;
